<div
  class="day"
  [ngClass]="eventsAppearance()"
  [class.weekend]="day().isWeekend"
  [class.not-in-month]="!day().inMonth"
  [class.today]="day().isToday"
  [class.past]="day().isPast"
  [class.selected]="selected()"
  stchPopover
  stchPopoverPlacement="bottomLeft"
  stchPopoverTrigger="hover"
  [stchPopoverDisabled]="day().events.length === 0 || eventsAppearance() === 'list' || popupDisabled()"
  [stchPopoverDelay]="400"
  [stchPopoverContent]="moreTemplate"
  [stchPopoverShowUntil]="popoverClose"
  [stchPopoverContext]="{ day: day() }"
  [stchPopoverFallbackPlacements]="['topLeft']"
>
  <div class="number">
    {{ displayDate() | dateFormat: 'dayNumber' }}
  </div>

  @if (eventsAppearance() === 'dots') {
    <div class="day-dots">
      @for (event of day().events; track event.id) {
        <div class="day-dots-item" [style.background-color]="event.color.primary || defaultEventColor"></div>
      }
    </div>
  }

  @if (eventsAppearance() === 'list') {
    <div class="day-list">
      <stch-small-events-preview-list
        [events]="events()"
        [maxEvents]="visibleEventCount()"
        (eventClicked)="eventClicked.emit($event)"
        (eventDblClicked)="eventDblClicked.emit($event)"
      />
      @if (hasMoreEvents()) {
        <app-button2
          appearance="primary-text"
          size="s"
          stchPopover
          stchPopoverPlacement="bottomLeft"
          stchPopoverTrigger="click"
          [stchPopoverContent]="moreTemplate"
          [stchPopoverShowUntil]="popoverClose"
          [stchPopoverFallbackPlacements]="['topLeft']"
          (click)="$event.stopPropagation()"
        >
          More
        </app-button2>
      }
    </div>
  }
</div>

<ng-template #moreTemplate>
  <stch-events-list-popup
    [events]="events()"
    [date]="displayDate()"
    [popoverClose]="popoverClose"
    (eventClicked)="eventClicked.emit($event)"
    (eventDblClicked)="eventDblClicked.emit($event)"
  />
</ng-template>
